export const scrollTop = (selector) => {
    try {
        let btn = document.querySelector(selector);

        btn.addEventListener('click', () => {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth",
            })
        });
    } catch (e) { }
} 
